import React, { Fragment, useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { t } from 'i18next'
import { useRecoilValue } from 'recoil'
import { Container, Button, Row, Col, Card, CardBody, CardFooter } from 'reactstrap'
import Swal from 'sweetalert2'

import env from '../../env/src_config'
import Breadcrumbs from '../../layout/breadcrumb/Breadcrumb'
import { headersState } from '../../recoil/recoil'
import { axiosError } from '../../helpers/response'
import { isNull } from '../../izUtils'
import { transformer, linker } from '../../helpers/fields'
import Spinner from '../../components/spinner/Spinner'
import { errorStatus } from '../../helpers/response'
import { getSingleItem } from '../../helpers/getSingleItem'
import DisplayFields from '../../helpers/displayFields'
import DictionaryInfoButton from '../../components/dictionary/DictionaryInfoButton'

const CreatePrice = () => {
    const Navigate = useNavigate();
    const { priceId, priceMethod } = useParams()

    const headers = useRecoilValue(headersState);
    const [inputs, setInputs] = useState(null)
    const [showErrors, setShowErrors] = useState(false)

    useEffect(() => {
        if (priceId === 'create' || (!isNull(priceMethod) && priceMethod === 'update')) {
            updateData(false, null);
        } else {
            getSingleItem(headers, priceId, '/api/prices/', Navigate).then(data => {
                if (!isNull(data)) {
                    setInputs(data.fields);
                }
            })
        }

    }, [priceId]) // eslint-disable-line react-hooks/exhaustive-deps

    const updateData = (save, passedInputs) => {
        let payload = { save };
        if (!isNull(passedInputs)) {
            const keys = Object.keys(passedInputs);
            payload.data = {};
            for (let i = 0; i < keys.length; i++) {
                if (!isNull(passedInputs[keys[i]].value) && passedInputs[keys[i]].value.length !== 0) {
                    payload.data[keys[i]] = passedInputs[keys[i]].value;
                } else {
                    payload.data[keys[i]] = "";
                }
            }
        }


        let method = 'post' // Create
        if (priceId !== 'create' && (!isNull(priceMethod) && priceMethod === 'update')) method = 'patch' // Update
        axios[method](env.api + '/api/prices/' + priceId, payload, {headers}).then(response => {
            if (save) {
                if (!isNull(response.data.state) && response.data.state === 'success') {
                    Swal.fire({
                        title: t('saved'),
                        text: response.data.message,
                        icon: 'success',
                        confirmButtonColor: 'var(--theme-default)',
                        confirmButtonText: t('ok'),
                    }).then(() => Navigate('/prices'))
                } else {
                    setShowErrors(true)
                    errorStatus(response.data, t);
                }
            }

            if (!isNull(response.data.data)) setInputs(transformer(response.data.data));
        }).catch(error => {
            axiosError(error, Navigate);
        });
    }

    const textChange = (value, name) => {
        let clonedInputs = {...inputs}
        clonedInputs[name].value = value;
        updateData(false, clonedInputs);
    }

    // Create fields
    const mapLinker = (field) => {
        const inputlinkerFields = {
            field,
            inputs,
            showErrors,
            showDictionary: {
                form: 'prices',
                fields: ['pricelist_type', 'active_from', 'working_hour_price', 'overtime_price', 'night_overtime_price', 'sunday_overtime_price', 'sunday_night_overtime_price', 'travel_price', 'intervention_price', 'programming_price', 'advisory_price', 'mileage_price'],
            },
            textHandler: (value, id) => textChange(value, id),
            selectHandler: (value, id) => textChange(value, id),
            dateHandler: (value, id) => textChange(value, id),
        }

        if (priceMethod === 'get') {
            if (!isNull(inputs[field])) return <DisplayFields key={'display-'+inputs[field].name} data={inputs[field]} />
        } else {
            return linker(inputlinkerFields);
        }
    }

    return (
        <Fragment>
            <Breadcrumbs parent={t('breadcrumb.priceList')} title={t('breadcrumb.price')} />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card className="ribbon-wrapper">
                            <CardBody>
                                <div className="ribbon ribbon-clip ribbon-primary">{ (priceId === 'create') ? t('prices.create.title') : ( priceMethod === 'update' ? t('prices.update.title') : t('prices.get.title') ) }</div>
                                {isNull(inputs) ?
                                    <Spinner />
                                    :
                                    <Fragment>
                                        <div className="theme-form">
                                            <Row>
                                                <Col sm="12" md="6">
                                                    { ['pricelist_type', 'active_from', 'working_hour_price', 'overtime_price', 'night_overtime_price', 'sunday_overtime_price', 'sunday_night_overtime_price'].map(field => mapLinker(field)) }
                                                </Col>
                                                <Col sm="12" md="6">
                                                    { ['travel_price', 'intervention_price', 'programming_price', 'advisory_price', 'mileage_price'].map(field => mapLinker(field)) }
                                                </Col>
                                            </Row>
                                        </div>
                                    </Fragment>
                                }
                            </CardBody>
                            {(priceId === 'create' || (!isNull(priceMethod) && (priceMethod === 'update' || priceMethod === 'draft'))) &&
                                <CardFooter>
                                    <div className="d-flex align-items-center justify-content-end mt-2">
                                        <Button color="primary" className="me-2" onClick={() => updateData(true, inputs)}>{t('save')}</Button>
                                        <DictionaryInfoButton code="prices.form.save" id="prices.form.save" />
                                    </div>
                                </CardFooter>
                            }
                        </Card>
                    </Col>
                </Row>
                <div className='d-flex flex-wrap justify-content-between mb-4'>
                    <div className="d-flex align-items-center mt-2">
                        <Button color="danger" className="me-2" onClick={() => Navigate(-1)}>{t('back')}</Button>
                        <DictionaryInfoButton code="prices.form.back" id="prices.form.back" />
                    </div>
                </div>
            </Container>
        </Fragment>
    )
}

export default CreatePrice